import { Component, Input, OnInit } from "@angular/core";
import { LINE_OF_BUSINESS_ENUM, LoggedInUserInformationService, LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure } from "@ptl/account-management";
import { RedirectService } from "src/app/angular-elements/shared/services/redirect.service";
import { ReducerUtilityService } from "src/app/shared/utility-services/reducer-utility.service";
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-agent-cubed-sso',
    templateUrl: './agent-cubed-sso.component.html',
    styleUrls: ['./agent-cubed-sso.component.scss'],
    standalone: false
})
export class AgentCubedSSOComponent implements OnInit {

    @Input() agentCubedLabel: string;
    @Input() lob: LINE_OF_BUSINESS_ENUM;

    userId = '';
    isAgentCube = false;

    constructor(
        private loggedInUserService: LoggedInUserInformationService,
        private reducerUtilityService: ReducerUtilityService,
        private redirectService: RedirectService
    ) { }

    async ngOnInit() {
        if (this.lob) {
            this.isAgentCube = this.loggedInUserService.isAgentCubeForLOB(this.lob);
        }
        else {
            this.isAgentCube = await this.loggedInUserService.isAgentCubeAwait();
        }

        const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);
        this.userId = loginInfo.userId;
    }

    submitSSOForm() {
        let destinationURL = "A3SP";
        let target = "https://" + environment.external.vendors.agentCubeUrl;
        let postParams = { userName: this.userId, destinationURL: destinationURL, target }
        this.redirectService.post(postParams);
    }

}

